<template>
  <div></div>
</template>

<script>
export default {
  methods: {
    isModified () {
      return false
    }
  }
}
</script>
